import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import {
  BrowseLevelsLayoutContext,
  getLevelSurfaceKey,
  type LevelSurfacePart,
} from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels._context";

/** A level keeps its presentation when its recycled row is released or reused. */
export function useLevelDetailsExpanded(
  levelIndex: number,
  part: LevelSurfacePart,
  defaultExpanded: boolean,
) {
  const surfaceKey = getLevelSurfaceKey(levelIndex, part);
  const [expanded, setLevelDetailsExpanded] = useContextSelectors(
    BrowseLevelsLayoutContext,
    (context) =>
      context.levelDetailsExpandedBySurface.get(`${context.browsedHanziScript}/${surfaceKey}`) ??
      defaultExpanded,
    (context) => context.setLevelDetailsExpanded,
  );
  const setExpanded = (value: boolean) => setLevelDetailsExpanded(surfaceKey, value);
  return { expanded, setExpanded };
}
